// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","mobileThreshold":"575px","textBlack":"#161616","container":"_3fDFJWUVw0uUyoa1qfGoNy","message":"_26V8oz_CB_Fnz5FGlVBkbM"};


//////////////////
// WEBPACK FOOTER
// ./src/common/error-api-handler/ErrorApiHandler.css
// module id = 465
// module chunks = 0 1 2